module.exports = __webpack_public_path__ + "media/images/browsers/opera-f46653a45444eea5c760cd2d967262f1.svg";